(() => {
  if (window.__itmOn) return; window.__itmOn = true;
  let sh = null, scrim = null, opener = null, open = false;
  const build = () => {
    if (sh) return;
    scrim = document.createElement("div"); scrim.className = "itm-scrim";
    sh = document.createElement("div"); sh.className = "itm-sheet"; sh.setAttribute("role", "dialog"); sh.setAttribute("aria-modal", "true"); sh.setAttribute("aria-labelledby", "itmT"); sh.tabIndex = -1;
    document.body.append(scrim, sh);
    scrim.addEventListener("click", close);
    sh.addEventListener("click", (e) => { if (e.target.closest("[data-itm-x]")) close(); });
  };
  const drag = () => {
    const h = sh.querySelector("[data-itm-drag]"); if (!h) return;
    let y0 = null, dy = 0;
    h.addEventListener("touchstart", (e) => { if (e.target.closest("[data-itm-x]")) return; y0 = e.touches[0].clientY; dy = 0; sh.classList.add("drag"); }, { passive: true });
    h.addEventListener("touchmove", (e) => { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); sh.style.transform = `translate(-50%,${dy}px)`; }, { passive: true });
    h.addEventListener("touchend", () => { if (y0 == null) return; sh.classList.remove("drag"); y0 = null; if (dy > 90) close(); else sh.style.transform = ""; });
  };
  function show(btn) {
    const tpl = btn.parentElement && btn.parentElement.querySelector("template[data-itm-tpl]"); if (!tpl) return;
    build(); opener = btn;
    sh.replaceChildren(tpl.content.cloneNode(true)); sh.style.transform = "";
    drag();
    open = true; scrim.classList.add("on"); document.documentElement.classList.add("itm-lock");
    requestAnimationFrame(() => { sh.classList.add("on"); sh.focus({ preventScroll: true }); });
    btn.setAttribute("aria-expanded", "true");
  }
  function close() {
    if (!open) return;
    sh.classList.remove("on"); sh.style.transform = "";
    scrim.classList.remove("on"); document.documentElement.classList.remove("itm-lock");
    open = false;
    if (opener) { opener.setAttribute("aria-expanded", "false"); if (opener.isConnected) opener.focus({ preventScroll: true }); }
  }
  document.addEventListener("click", (e) => { const b = e.target.closest("[data-itm-open]"); if (b) { e.preventDefault(); show(b); } });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && open) close(); });
})();
